var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-wrapper",
    {
      attrs: {
        linkedForm: _vm.linkedForm,
        redirection: _vm.redirectionTo,
        store: _vm.store,
        current: _vm.current,
        labelSaveAndAction: _vm.saveAndLabelAction
      },
      on: { "catch-errors": _vm.catchErrors }
    },
    [
      _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.formTitle))]),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "company",
            activeFields: ["company"],
            toggleAllowed: true,
            title: _vm.$t.__("common.labels.the_company")
          }
        },
        [
          _c("form-fields-company", {
            ref: "main",
            attrs: { currentStore: _vm.current, error: _vm.error.errors },
            on: { "change-type": _vm.changeType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "custom-fields",
            activeFields: ["custom-fields"],
            toggleAllowed: true,
            title: _vm.$t.__(
              "pages.forms.ThirdCompaniesForm.company_custom_fields"
            )
          }
        },
        [
          _c("form-fields-custom-fields", {
            ref: "custom-fields",
            attrs: {
              currentStore: _vm.current,
              currentCustomfields: _vm.getCustomFields
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "legal-and-billing",
            activeFields: ["legal-and-billing"],
            toggleAllowed: true,
            title: _vm.$t.__(
              "pages.forms.ThirdCompaniesForm.billing_and_legal_information"
            )
          }
        },
        [
          _c("form-fields-legal-and-billing", {
            attrs: { currentStore: _vm.current, error: _vm.error.errors }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "address",
            toggleAllowed: true,
            activeFields: ["address"],
            title: _vm.$t.__("pages.forms.ThirdCompaniesForm.company_address")
          }
        },
        [
          _vm._l(_vm.getAddresses, function(address, index) {
            return _c("form-fields-address", {
              key: index,
              attrs: {
                index: _vm.formatIndex(index),
                currentStore: _vm.current
              }
            })
          }),
          _vm._v(" "),
          _vm.getAddressesFieldsStatus === "saved"
            ? _c("CompassButton", {
                staticClass: "wp-10 mt-2",
                attrs: {
                  label: _vm.$t.__("common.actions.add_address"),
                  type: "secondary"
                },
                on: {
                  click: function($event) {
                    return _vm.createNewAddress()
                  }
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "contact",
            toggleAllowed: true,
            activeFields: ["contact"],
            title: _vm.$t.__("pages.forms.ThirdCompaniesForm.company_contacts")
          }
        },
        [
          _c("form-fields-add-contact", {
            attrs: {
              currentStore: _vm.current,
              addToListWording: _vm.addToContactListWording,
              goBackMsg: _vm.goBackMsg
            },
            on: { "to-children-form": _vm.pushToChildrenForm }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.getType !== "prospect"
        ? _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "accounting",
                toggleAllowed: true,
                title: _vm.$t.__("common.labels.accounting")
              }
            },
            [
              _c("form-fields-accounting", {
                attrs: { currentStore: _vm.current }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }